import React from 'react';
import { ChevronsUp, ChevronUp, ChevronDown, ChevronsDown, Trash2, Copy, Type, Bell, Layers, Link } from 'lucide-react';

export function VisualContextMenu({ x, y, onClose, onMoveToFront, onMoveToBack, onMoveForward, onMoveBackward, onDelete, onDuplicate, placeholders, onInsertPlaceholder, onCreateAlert, onPromoteToLibrary, isLinked }) {
  return (
    <div className="fixed inset-0 z-[100]" onClick={onClose} onContextMenu={e => { e.preventDefault(); onClose(); }}>
      <div
        className="glass-card rounded-lg shadow-2xl border border-border/50 py-1 w-48"
        style={{ position: 'fixed', left: x, top: y, zIndex: 101 }}
        onClick={e => e.stopPropagation()}
        data-testid="visual-context-menu"
      >
        <button onClick={onMoveToFront} className="w-full text-left px-3 py-1.5 text-[11px] text-foreground hover:bg-muted/30 transition-colors flex items-center gap-2" data-testid="ctx-move-to-front">
          <ChevronsUp className="w-3.5 h-3.5" /> Move to Front
        </button>
        <button onClick={onMoveForward} className="w-full text-left px-3 py-1.5 text-[11px] text-foreground hover:bg-muted/30 transition-colors flex items-center gap-2" data-testid="ctx-move-forward">
          <ChevronUp className="w-3.5 h-3.5" /> Move Forward
        </button>
        <button onClick={onMoveBackward} className="w-full text-left px-3 py-1.5 text-[11px] text-foreground hover:bg-muted/30 transition-colors flex items-center gap-2" data-testid="ctx-move-backward">
          <ChevronDown className="w-3.5 h-3.5" /> Move Backward
        </button>
        <button onClick={onMoveToBack} className="w-full text-left px-3 py-1.5 text-[11px] text-foreground hover:bg-muted/30 transition-colors flex items-center gap-2" data-testid="ctx-move-to-back">
          <ChevronsDown className="w-3.5 h-3.5" /> Move to Back
        </button>
        <div className="border-t border-border/30 my-1" />
        {onDuplicate && (
          <button onClick={onDuplicate} className="w-full text-left px-3 py-1.5 text-[11px] text-foreground hover:bg-muted/30 transition-colors flex items-center gap-2" data-testid="ctx-duplicate">
            <Copy className="w-3.5 h-3.5" /> Duplicate
          </button>
        )}
        {onCreateAlert && (
          <button onClick={onCreateAlert} className="w-full text-left px-3 py-1.5 text-[11px] text-amber-400 hover:bg-amber-500/10 transition-colors flex items-center gap-2" data-testid="ctx-create-alert">
            <Bell className="w-3.5 h-3.5" /> Create Alert
          </button>
        )}
        {onPromoteToLibrary && !isLinked && (
          <button onClick={onPromoteToLibrary} className="w-full text-left px-3 py-1.5 text-[11px] text-primary hover:bg-primary/10 transition-colors flex items-center gap-2" data-testid="ctx-promote-library">
            <Layers className="w-3.5 h-3.5" /> Save to Library
          </button>
        )}
        {isLinked && (
          <div className="px-3 py-1.5 text-[11px] text-emerald-400 flex items-center gap-2">
            <Link className="w-3.5 h-3.5" /> Linked to Library
          </div>
        )}
        <button onClick={onDelete} className="w-full text-left px-3 py-1.5 text-[11px] text-destructive hover:bg-destructive/10 transition-colors flex items-center gap-2" data-testid="ctx-delete">
          <Trash2 className="w-3.5 h-3.5" /> Delete
        </button>
        {/* Placeholders (Report mode only, text visuals only) */}
        {placeholders && placeholders.length > 0 && onInsertPlaceholder && (
          <>
            <div className="border-t border-border/30 my-1" />
            <p className="px-3 py-0.5 text-[8px] text-muted-foreground uppercase tracking-wider font-semibold">Insert Placeholder</p>
            {placeholders.map(p => (
              <button key={p.value} onClick={() => onInsertPlaceholder(p.value)} className="w-full text-left px-3 py-1.5 text-[11px] text-foreground hover:bg-muted/30 transition-colors flex items-center justify-between" data-testid={`ctx-placeholder-${p.value}`}>
                <span className="flex items-center gap-1.5"><Type className="w-3 h-3 text-muted-foreground/70" /> {p.label}</span>
                <span className="text-[8px] text-muted-foreground/70 font-mono">{p.value}</span>
              </button>
            ))}
          </>
        )}
      </div>
    </div>
  );
}
